export const sectionsData = [
    { id: 'hero', name: 'I. HERO' },
    { id: 'intro', name: 'II. INTRO' },
    { id: 'services', name: 'III. SERVICES' },
    { id: 'who-am-i', name: 'IV. WHO I AM' },
    { id: 'my-belief', name: 'V. MY BELIEF' },
    { id: 'why-mentor', name: 'VI. WHY I MENTOR' },
    { id: 'experience', name: 'VII. EXPERIENCE' },
    { id: 'industries', name: 'VIII. INDUSTRIES' },
    { id: 'page9', name: 'IX. PAGE9' },
    { id: 'education', name: 'X. EDUCATION' },
    { id: 'contacts', name: 'XI. contacts' },
];
